import React, { Component } from 'react';
import { Container, Row, Col, Table, Breadcrumb, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCurrentProfile } from '../../actions/profileAction';
import Card from '../../components/Card/Card';
import Spinner from '../common/Spinner';
import { confirmAlert } from 'react-confirm-alert';
import { getStudentStatsAdminView, getNumberOfStudentsPerConference, getNumberOfStudentsPerConferenceByDay, getConferenceStatus, getChangeConferenceStatus, deleteConference, getUsers } from '../../actions/clientActions';
import { StatsCard } from '../StatsCard/StatsCard';
import ReactToExcel from 'react-html-table-to-excel';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import Swal from 'sweetalert2'
import { Pie } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';
import { Line } from 'react-chartjs-2';
import dateFormat from "dateformat";
import '../../App.css';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend
);
class AdminStatistic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      student: '',
      search: ''
    };
  }

  componentDidMount() {
    this.props.getCurrentProfile();
    this.props.getStudentStatsAdminView();
    this.props.getNumberOfStudentsPerConference();
    this.props.getNumberOfStudentsPerConferenceByDay();
    this.props.getConferenceStatus();
    this.props.getUsers();
  }

  updateSearch(e) {
    this.setState({ search: e.target.value });
  }
  changeStatusToActive(_id) {
    Swal.fire({
      title: 'Da li sigurno želite da zatvorite predavanje?',
      showDenyButton: true,
      confirmButtonText: 'Da',
      denyButtonText: 'Ne',
      customClass: {
        actions: 'my-actions',
        confirmButton: 'order-1',
        denyButton: 'order-2',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        (this.props.getChangeConferenceStatus(_id, 'Neaktivno'))
      }
    })
  }
  deleteConf(_id) {
    Swal.fire({
      title: 'Da li sigurno želite da obrišete predavanje?',
      showDenyButton: true,
      confirmButtonText: 'Da',
      denyButtonText: 'Ne',
      customClass: {
        actions: 'my-actions',
        confirmButton: 'order-1',
        denyButton: 'order-2',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.props.deleteConference(_id)
      }
    })
  }
  changeStatusToInactive(_id) {
    Swal.fire({
      title: 'Započni predavanje',
      text: 'Da li sigurno želite da započnete predavanje ?',
      showDenyButton: true,
      confirmButtonText: 'Da',
      denyButtonText: 'Ne',
      customClass: {
        actions: 'my-actions',
        confirmButton: 'order-1',
        denyButton: 'order-2',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.props.getChangeConferenceStatus(_id, 'Aktivno')
      }
    })
  }
  render() {
    const { loading } = this.props.student;
    const users = this.props.users.users;

    let count = users.length;
    let admini;
    let studenti;
    var countAdmin = 0;
    var countStudent = 0;
    for (const user of users) {
      if (user.position === 'Admin') {
        countAdmin += 1;
      }
      else if (user.position === 'Student') {
        countStudent += 1;
      }
    }
    admini = countAdmin;
    studenti = countStudent;

    const students = this.props.participant.participantStats.filter(students => {
      return (
        students.sname.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1);
    });
    const stats = this.props.participants1.participantPerConference;
    const statsByDay = this.props.participants1.participantPerConferenceByDay;
    console.log(stats);
    console.log(statsByDay);
    const conferences = this.props.participants.conferenceStatus;
    let sumConferences = conferences.length;
    console.log(conferences);
    let statsItems;
    let chartItems;
    let labelsBar = [];
    let labelsUp = [];
    let seriesBarP = [];
    let labelsBarByDay = [];
    let seriesBarByDay = [];
    console.log(stats);
    let numOfConference = stats.length;
    //bar chart count by day 
    for (let i = 0; i < statsByDay.length; i++) {
      labelsBarByDay.push(dateFormat(statsByDay[i]._id, "dd.mm.yyyy."));
      seriesBarByDay.push(statsByDay[i].count);
    }
    console.log(labelsBarByDay);

    const options = {
      responsive: true,
      scales: {
          y: {
              beginAtZero: true
          }
      },
      plugins: {
        legend: {
          position: 'top',
        },
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Prisutni učesnici po danima',
        },
      },
    };   
    const datajsByDayLine = {
      labels: labelsBarByDay,
      datasets: [{
        label: 'Broj prisustva',
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
        data: seriesBarByDay
      }]
    };
    const datajsByDay = {
      labels: labelsBarByDay,
      datasets: [{
        label: 'Broj prisustva',
        fill: true,
        lineTension: 1,
        backgroundColor: [
          '#AC7088',
          '#829460',
          '#FFB9B9',
          '#98A8F8',
          '#C4DFAA',
          '#AC7D88',
          '#FFB3B3',
          '#FF8DC7',
          '#CDFCF6',
          '#F2D388',
          '#54BAB9',
          '#C4DFAA',
          '#AF7AB3'
        ],
        borderColor: 'rgba(51, 153, 255,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(51, 153, 255,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(51, 153, 255,1)',
        pointHoverBorderColor: ['#AC7088',
          '#829460',
          '#FFB9B9',
          '#98A8F8',
          '#C4DFAA',
          '#AC7D88',
          '#FFB3B3',
          '#FF8DC7',
          '#CDFCF6',
          '#F2D388',
          '#54BAB9',
          '#C4DFAA',
          '#AF7AB3'],
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: seriesBarByDay
      }]
    };

    if (stats === null || loading) {
      chartItems = (
        <tr>
          <td>
            <Spinner />
          </td>
        </tr>
      );
    }
    else {
      for (let i = 0; i < stats.length; i++) {
        labelsBar.push(stats[i]._id);
        seriesBarP.push(stats[i].count);
      }
    }

    //bar chart count
    const datajs = {
      labels: labelsBar,
      datasets: [{
        label: 'Broj prisustva',
        fill: true,
        lineTension: 1,
        backgroundColor: [
          '#AC7088',
          '#829460',
          '#FFB9B9',
          '#98A8F8',
          '#C4DFAA',
          '#AC7D88',
          '#FFB3B3',
          '#FF8DC7',
          '#CDFCF6',
          '#F2D388',
          '#54BAB9',
          '#C4DFAA',
          '#AF7AB3'
        ],
        borderColor: 'rgba(51, 153, 255,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(51, 153, 255,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(51, 153, 255,1)',
        pointHoverBorderColor: ['#AC7088',
          '#829460',
          '#FFB9B9',
          '#98A8F8',
          '#C4DFAA',
          '#AC7D88',
          '#FFB3B3',
          '#FF8DC7',
          '#CDFCF6',
          '#F2D388',
          '#54BAB9',
          '#C4DFAA',
          '#AF7AB3'],
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: seriesBarP
      }]
    };


    //pie chart count
    const data = {
      labels: labelsBar,
      datasets: [
        {
          label: 'Broj prisustva',
          data: seriesBarP,
          backgroundColor: ['#DEB6AB',
            '#C4DFAA',
            '#FFB3B3',
            '#C4D7E0',
            '#E9DAC1',
            '#AC7D88',
            '#FFB3B3',
            '#FF8DC7',
            '#CDFCF6',
            '#F2D388',
            '#54BAB9',
            '#C4DFAA',
            '#AF7AB3'],
          borderColor: ['#AC7088',
            '#829460',
            '#F675A8',
            '#98A8F8',
            '#DEB6AB',
            '#AC7D88',
            '#E4D1B9',
            '#FF8DC7',
            '#CDFCF6',
            '#F2D388',
            '#54BAB9',
            '#C4DFAA',
            '#AF7AB3'],
          borderWidth: 2,
        },
      ],
    };

    if (stats === null || loading) {
      statsItems = (
        <tr>
          <td>
            <Spinner />
          </td>
        </tr>
      );
    }
    else {
      if (stats.length > 0) {
        statsItems = stats.map(stats => (
          <tr key={stats._id}>
            <td style={{ border: '0px' }}>{stats._id}</td>
            <td style={{ border: '0px' }}>{stats.count}</td>
          </tr>

        ))
      }
      else {
        statsItems = (
          <tr>
            <td>Trenutno nema podataka za prikaz</td>
          </tr>
        );
      }
    }

    let studentItems;
    if (students === null || loading) {
      studentItems = (
        <tr>
          <td>
            <Spinner />
          </td>
        </tr>
      );
    }

    else {
      if (students.length > 0) {

        students.forEach(element => {

        });
        studentItems = students.map(student => (
          <tr key={student._id}>
            <td style={{ width: '25%', border: '0px' }}>{student.sname}</td>
            <td style={{ width: '25%', border: '0px' }}>{student._id}</td>
            <td style={{ width: '25%', border: '0px' }}>{student.count}</td>
            <td style={{ width: '25%', border: '0px' }}>{(() => {
              switch (true) {
                case student.count >= 6:
                  return (
                    <span>
                      Da
                    </span>
                  );
                default:
                  return (
                    <span>
                      Ne
                    </span>
                  );
              }
            })()}</td>
          </tr>

        ));
      }
      else {
        studentItems = (
          <tr>
            <td>Trenutno nema podataka za prikaz</td>
          </tr>
        );
      }
    }

    let confItems;
    if (confItems === null || loading) {
      confItems = (
        <tr>
          <td>
            <Spinner />
          </td>
        </tr>
      );
    }
    else {
      if (conferences.length > 0) {
        confItems = conferences.map(conference => (
          <tr key={conference._id}>
            <td style={{ border: '0px' }}>{conference.conferenceFullName}</td>
            <td style={{ border: '0px' }}>

              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip id="button-tooltip">
                  Započnite sa čekiranjem učesnika
                </Tooltip>}
              >
                <Link
                  to={`/AdminStatistic/ConferenceTemplate/${conference._id}`}
                  className="btn btn-fill btn-sm"
                  style={{ backgroundColor: '#6096B4', border: 'none' }}
                >
                  Predavanje
                </Link>
              </OverlayTrigger>
            </td>
            <td style={{ border: '0px' }}>
              {conference.statusConference === 'Aktivno' ? (
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip id="button-tooltip">
                    Kada zatvorite predavanje više nije moguće čekiranje učesnika
                  </Tooltip>}
                >
                  <button
                    style={{ backgroundColor: '#EF9A53', border: 'none' }}
                    type="button"
                    className="btn-fill btn btn-sm"
                    onClick={this.changeStatusToActive.bind(this, conference._id, 'Aktivno')}
                  >
                    Deaktiviraj
                  </button>
                </OverlayTrigger>
              ) :
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip id="button-tooltip">
                    Otvorite predavanje kako biste omogućili čekiranje
                  </Tooltip>}
                >
                  <button
                    style={{ backgroundColor: '#ABC270', border: 'none' }}
                    type="button"
                    className="btn-fill btn btn-sm"
                    onClick={this.changeStatusToInactive.bind(this, conference._id, 'Neaktivno')}
                  >
                    Aktiviraj
                  </button>
                </OverlayTrigger>}
            </td>
            <td style={{ border: '0px' }}>
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip id="button-tooltip">
                  Izmenite informacije o predavanju
                </Tooltip>}
              >
                <Link
                  to={`/AdminStatistic/ChangeConfInfo/${conference._id}`}
                  className="btn btn-fill btn-secondary btn-sm"
                >
                  Izmeni
                </Link>
              </OverlayTrigger>
            </td>
            <td>
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip id="button-tooltip">
                  Izbrišite predavanje iz baze
                </Tooltip>}
              >
                <button
                  type="button"
                  style={{ backgroundColor: '#E97777', border: 'none' }}
                  className="btn-fill btn btn-sm"
                  onClick={this.deleteConf.bind(this, conference._id)}
                >
                  Izbriši
                </button>
              </OverlayTrigger>
            </td>
          </tr >

        ))
      } else {
        confItems = (
          <tr>
            <td>Trenutno nema podataka za prikaz</td>
          </tr>
        );
      }
    }

    return (
      <div className="content">
        <Row className='justify-content-center'>
          <Col lg={3} sm={3}>
            <StatsCard
              bigIcon={<i className="pe-7s-date" style={{ color: '#525E75' }} />}
              statsText="Dana"
              statsValue={
                <CountUp
                  className="account-balance"
                  start={0}
                  end={4}
                  duration={1}
                  useGrouping={true}
                />}
            />
          </Col>
          <Col lg={3} sm={3}>
            <StatsCard
              bigIcon={<i className="pe-7s-micro" style={{ color: '#525E75' }} />}
              statsText="Predavanja"
              statsValue={
                <CountUp
                  className="account-balance"
                  start={0}
                  end={sumConferences}
                  duration={1}
                  useGrouping={true}
                />}
            />
          </Col>
          <Col lg={3} sm={3}>
            <StatsCard
              bigIcon={<i className="pe-7s-id" style={{ color: '#525E75' }} />}
              statsText="Studenata"
              statsValue={
                <CountUp
                  className="account-balance"
                  start={0}
                  end={studenti}
                  duration={1}
                  useGrouping={true}
                />}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={6} sm={3}>

            <Card
              ctTableFullWidth
              ctTableResponsive
              content={
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Breadcrumb>
                    <Breadcrumb.Item active>
                      <Link
                        style={{ textDecoration: 'none', color: '#525E75' }}
                        to={`/AdminStatistic/ChangeConfInfo/${'NewLecture'}`}
                      >
                        Napravi novo predavanje
                      </Link></Breadcrumb.Item>
                    <Breadcrumb.Item active>
                      <Link
                        style={{ textDecoration: 'none', color: '#525E75' }}
                        to={`/AdminStatistic/AddStudents`}
                      >
                        Dodaj učesnike
                      </Link>
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </div>
              }
            />
          </Col>
        </Row>

        <Container fluid>
          <Row className='justify-content-center'>
            <Col md={6}>
              <Card
                title="Status predavanja"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover bordered>
                    <thead>
                      <tr>
                        <th style={{ border: '0px' }}>Predavanje</th>
                        <th style={{ border: '0px' }} />
                        <th style={{ border: '0px' }}>Akcije</th>
                        <th style={{ border: '0px' }} />
                      </tr>
                    </thead>
                    <tbody>{confItems}</tbody>
                  </Table>
                }
              />
              <Card
                title="Prisustvo na predavanjima"
                category="Po predavanju"
                ctTableFullWidth
                ctTableResponsive
                content={<>
                  <Table striped hover bordered id='po_predavanju'>
                    <thead>
                      <tr>
                        <th style={{ border: '0px' }}>Predavanje</th>
                        <th style={{ border: '0px' }}>Prisutni</th>
                      </tr>
                    </thead>
                    <tbody>{statsItems}</tbody>
                  </Table>

                  <div className="col-md-4">
                    <ReactToExcel
                      font="TimesNewRoman"
                      className="btn btn-fill btn-secondary btn-sm"
                      table="po_predavanju"
                      filename={'Statistika predavanja ' + new Date().toLocaleDateString("rs-RS")}
                      sheet="sheet 1"
                      buttonText="Preuzmi .xls"
                    />
                  </div>
                </>}
              />
              <Row> <Col>
                <Card
                  id="chartActivity"
                  title={'Statistika po predavanjima bar chart [' + [numOfConference] + ']'}
                  content={
                    <><div>
                      <Bar
                        ref="chart"
                        data={datajs}
                        height={250}
                        options={{
                          scale: {
                            ticks: {
                              precision: 0
                            }
                          },
                          plugins: {
                            legend: {
                              display: false
                            }
                          },
                          maintainAspectRatio: false
                        }}
                        datasetIdKey='id'
                      />
                    </div></>
                  }
                />
              </Col>
</Row>
              <Col md={{ span: 8, offset: 2 }}>
                <Card
                  id="chartActivity"
                  title={'Statistika po predavanjima pie chart [' + [numOfConference] + ']'}

                  content={<div><Pie data={data} /></div>} />

              </Col>
              
              <Col>
                <Card
                  id="chartActivity"
                  title={'Statistika prisustva po danima'}

                  content={
                    <><div>
                      <Line
                        ref="chart"
                        data={datajsByDayLine}
                        height={250}
                        options={options}
                        datasetIdKey='idB'
                      />
                    </div> <br></br> <hr></hr>
                    <div>
                      <Bar
                        ref="chart"
                        data={datajsByDay}
                        height={250}
                        options={{
                          scale: {
                            ticks: {
                              precision: 0
                            }
                          },
                          plugins: {
                            legend: {
                              display: false
                            }
                          },
                          maintainAspectRatio: false
                        }}
                        datasetIdKey='idBD'
                      /></div></>
                  }
                />
              </Col> 
            </Col>
            <Col md={6}>
              <div>
                <Container fluid>
                  <Row className='justify-content-center'>
                    <div className="col-md-8">
                      <input
                        name="search"
                        type="text"
                        placeholder="&#xf002; Pretraga studenata..."
                        value={this.state.search}
                        onChange={this.updateSearch.bind(this)}
                        style={{ marginBottom: '33px', fontFamily: 'FontAwesome' }}
                        className="form-control form-control-lg col-md-4"
                      />
                    </div>
                    <div className="col-md-4">
                      <ReactToExcel
                        font="TimesNewRoman"
                        className="btn btn-fill btn-secondary btn-sm"
                        table="table-to-xls"
                        filename={'Statistika studenata ' + new Date().toLocaleDateString("rs-RS")}
                        sheet="sheet 1"
                        buttonText="Preuzmi .xls"
                      />
                    </div>
                  </Row>
                </Container>
                <Card
                  style={{ innerHeight: '529px' }}
                  title="Prisustvo na predavanjima"
                  category="Po studentu"
                  ctTableFullWidth
                  ctTableResponsive
                  content={
                    <Table striped hover bordered id="table-to-xls" style={{ display: 'block', height: '700px', overflowY: 'scroll' }}>
                      <thead>
                        <tr style={{ width: '100%' }}>
                          <th style={{ width: '25%', border: '0px' }}>Student</th>
                          <th style={{ width: '25%', border: '0px' }}>Email</th>
                          <th style={{ width: '25%', border: '0px' }}>Broj prisustva</th>
                          <th style={{ width: '25%', border: '0px' }}>Dobija sertifikat</th>
                        </tr>
                      </thead>
                      <tbody>{studentItems}</tbody>
                    </Table>
                  }
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

AdminStatistic.propTypes = {
  deleteConference: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  student: PropTypes.object.isRequired,
  participants1: PropTypes.object.isRequired,
  participants: PropTypes.object.isRequired,
  participant: PropTypes.object.isRequired,
  getStudentStatsAdminView: PropTypes.func.isRequired,
  getCurrentProfile: PropTypes.func.isRequired,
  getNumberOfStudentsPerConference: PropTypes.func.isRequired,
  getNumberOfStudentsPerConferenceByDay: PropTypes.func.isRequired,
  getConferenceStatus: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  getChangeConferenceStatus: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  student: state.student,
  users: state.users,
  participants1: state.participant,
  participants: state.participant,
  participant: state.participant,
  auth: state.auth,
});

export default connect(
  mapStateToProps,
  { getCurrentProfile, getStudentStatsAdminView, getNumberOfStudentsPerConference, getNumberOfStudentsPerConferenceByDay, getConferenceStatus, getChangeConferenceStatus, deleteConference, getUsers }
)(AdminStatistic);
